import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import { bindAll } from '@bibliocommons/utils-react';
import { Button } from '@bibliocommons/deprecated-base-buttons';
import { Cross } from '@bibliocommons/deprecated-base-icons';
import './ActiveFilterToken.scss';

export default class ActiveFilterToken extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter() {
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render() {
    const btnClass = cn('cp-filter-token', this.props.className);
    return (
      <Button
        handleClick={this.handleToggleFilter}
        data-test-id={`${this.props.fieldId}-${this.props.filter.get('value')}-active-filter`}
        className={btnClass}
        dataKey="active-filter-button"
      >
        {this.props.filterLabel}
        <Cross className="extra-small" />
      </Button>
    );
  }
}

ActiveFilterToken.propTypes = {
  className: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  filter: ImmutablePropTypes.map,
  filterLabel: PropTypes.string.isRequired,
  handleToggleFilter: PropTypes.func
};
